// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aPGQOkrHMMHIfa_WfLRY{align-items:center;gap:10px;padding:6px 22px 17px;display:flex}.aPGQOkrHMMHIfa_WfLRY .zG41jMl7UdIfrLQh2q0Z{flex:1;align-items:center}.aPGQOkrHMMHIfa_WfLRY .zG41jMl7UdIfrLQh2q0Z .eGQ0VKDq8Epv_zZWx3bJ{margin-left:5px;margin-right:8px}.aPGQOkrHMMHIfa_WfLRY .zG41jMl7UdIfrLQh2q0Z input{height:20px;font-size:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aPGQOkrHMMHIfa_WfLRY`,
	"search": `zG41jMl7UdIfrLQh2q0Z`,
	"icon": `eGQ0VKDq8Epv_zZWx3bJ`
};
export default ___CSS_LOADER_EXPORT___;
